// eslint-disable-next-line max-classes-per-file
import EstimateStatus from '../../enums/EstimateStatus';

class EstimateItem {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  name: string;
  quantity: number;
  price: number;
  itemNumber: number = 0;
  checked: boolean = false;

  constructor(data: any = {}) {
    const createdAt = new Date(data.createdAt);

    this.id = data.id;
    this.createdAt = createdAt;
    this.updatedAt = new Date(data.updatedAt);
    this.name = data.name;
    this.quantity = data.quantity;
    this.price = data.price;
  }

  public toggleChecked() {
    this.checked = !this.checked;
  }
}

export class EstimateProduct extends EstimateItem {
  productId: number;
  isGrouped: boolean;

  constructor(data: any = {}) {
    super(data);

    this.productId = data.productId;
    this.isGrouped = data.isGrouped;
  }
}

export class EstimateService extends EstimateItem {
  serviceId: number;
  description: string;
  isGrouped: boolean;

  constructor(data: any = {}) {
    super(data);

    this.serviceId = data.serviceId;
    this.description = data.description;
    this.isGrouped = data.isGrouped;
  }
}

export class EstimateTag {
  tagId: number;
  name: string;
  color: string;

  constructor(data: any = {}) {
    this.tagId = data.tagId;
    this.name = data.name;
    this.color = data.color;
  }
}

export class EstimateEquipment {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  equipmentId: number;
  name: string;
  brand: string;
  model: string;
  serialNumber: string;
  description: string;
  checked: boolean = false;

  constructor(data: any = {}) {
    this.id = data.id;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
    this.equipmentId = data.equipmentId;
    this.name = data.name;
    this.brand = data.brand;
    this.model = data.model;
    this.serialNumber = data.serialNumber;
    this.description = data.description;
  }

  toggleChecked() {
    this.checked = !this.checked;
  }
}

export class EstimateViewModel {
  id: number;
  number: string;
  transactionNatureId: number;
  transactionNatureName: string;
  status: EstimateStatus;
  companyId: number;
  companyIdentifier: string;
  companyType: number;
  companyName: string;
  customerId: number;
  customerIdentifier: string;
  customerType: number;
  customerName: string;
  customerEmail: string;
  createdAt: Date;
  updatedAt: Date;
  subTotal: number;
  discount: number;
  total: number;

  estimateProducts: EstimateProduct[];
  estimateServices: EstimateService[];
  estimateEquipments: EstimateEquipment[];
  estimateTags: EstimateTag[];

  constructor(data: any = {}) {
    const createdAt = new Date(data.createdAt);

    this.id = data.id;
    this.number = data.number;
    this.transactionNatureId = data.transactionNatureId;
    this.transactionNatureName = data.transactionNatureName;
    this.status = data.status;
    this.companyId = data.companyId;
    this.companyIdentifier = data.companyIdentifier;
    this.companyType = data.companyType;
    this.companyName = data.companyName;
    this.customerId = data.customerId;
    this.customerIdentifier = data.customerIdentifier;
    this.customerType = data.customerType;
    this.customerName = data.customerName;
    this.customerEmail = data.customerEmail;
    this.createdAt = createdAt;
    this.updatedAt = new Date(data.updatedAt);
    this.subTotal = data.subTotal || 0;
    this.discount = data.discount || 0;
    this.total = data.total || 0;

    this.estimateProducts = data.estimateProducts.map(
      (estimateProduct: any) => new EstimateProduct(estimateProduct)
    );
    this.estimateServices = data.estimateServices.map(
      (estimateService: any) => new EstimateService(estimateService)
    );
    this.estimateEquipments = data.estimateEquipments.map(
      (estimateEquipment: any) => new EstimateEquipment(estimateEquipment)
    );
    this.estimateTags =
      (data.estimateTags &&
        data.estimateTags.map(
          (estimateTag: any) => new EstimateTag(estimateTag)
        )) ||
      [];
  }
}
